"use strict";var t=(s=>(s["SAP-icons"]="SAP-icons-v4",s.horizon="SAP-icons-v5",s["SAP-icons-TNT"]="tnt",s.BusinessSuiteInAppSymbols="business-suite",s))(t||{});const n=e=>t[e]?t[e]:e;export default t;export{n as getIconCollectionByAlias};
//# sourceMappingURL=IconCollectionsAlias.js.map
